
function rand4HexStr() {
  return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}
export default function() {
    // Adapted from StackOverflow - Jon Surrell
    // http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
  return `${rand4HexStr() + rand4HexStr()}-${rand4HexStr()}-${rand4HexStr()}-${
        rand4HexStr()}-${rand4HexStr()}${rand4HexStr()}${rand4HexStr()}`;
}
